// region ---- mixins

export const Text32x400Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 32px!important;
  font-weight: 400;
  line-height: 1.33!important;
`;

export const Text18x400Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 18px!important;
  font-weight: 400;
  line-height: 20px!important;
`;

export const Text20x400Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 20px!important;
  font-weight: 400;
  line-height: 20px!important;
`;

export const Text16x700Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 16px!important;
  font-weight: 700;
  line-height: 20px!important;
`;

export const Text16x500Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 16px!important;
  font-weight: 500;
  line-height: 20px!important;
`;

export const Text14x500Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 14px!important;
  font-weight: 500;
  line-height: 20px!important;
`;

export const Text14x400Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 14px!important;
  font-weight: 400;
  line-height: 20px!important;
`;

export const Text14x700Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 14px!important;
  font-weight: 700;
  line-height: 20px!important;
`;

export const Text12x700Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 12px!important;
  font-weight: 700;
  line-height: 20px!important;
`;

export const Text10x400Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 10px!important;
  font-weight: 400;
  line-height: 14px!important;
`;

export const Text12x500Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 12px!important;
  font-weight: 500;
  line-height: 16px!important;
`;

export const Text12x400Mixin = `
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif!important;
  font-size: 12px!important;
  font-weight: 400;
  line-height: 20px!important;
`;
// endregion

export const TextSubtitle4RMMixin = `
  font: 500 12px/20px Roboto, sans-serif;
`;

export const TextMetric5RMMixin = `
  font: 500 12px/20px Roboto, sans-serif;
`;

export const TextBody2RRMixin = `
  font: 400 14px/20px Roboto, sans-serif;
`;

export const TextH1OBMixin = `
  font: 700 48px/64px Oswald, sans-serif;
  text-transform: uppercase;
`;

export const TextH2OMMixin = `
  font: 400 36px/52px Oswald, sans-serif;
  text-transform: uppercase;
`;

export const TextH3OMMixin = `
  font: 500 28px/40px Oswald, sans-serif;
  text-transform: uppercase;
`;

export const TextH4RMMixin = `
  font: 500 28px/40px Roboto, sans-serif;
`;

export const TextH5RMMixin = `
  font: 500 24px/36px Roboto, sans-serif;
`;

export const TextSubtitle1RMMixin = `
  font: 500 20px/28px Roboto, sans-serif;
`;

export const TextSubtitle2RBMixin = `
  font: 700 16px/24px Roboto, sans-serif;
`;

export const TextSubtitle3RMMixin = `
  font: 500 14px/20px Roboto, sans-serif;
`;

export const TextSubtitle4CAPSRMMixin = `
  font: 500 12px/20px Roboto, sans-serif;

  text-transform: uppercase;
`;

export const TextBody1RRMixin = `
  font: 400 16px/24px Roboto, sans-serif;
`;

export const TextBody3RRMixin = `
  font: 400 12px/20px Roboto, sans-serif;
`;

export const TextLabel1CAPSRBMixin = `
  font: 700 10px/12px Roboto, sans-serif;

  text-transform: uppercase;
`;

export const TextLabel2CAPSRBMixin = `
  font: 700 08px/10px Roboto, sans-serif;
  text-transform: uppercase;
`;

export const TextButton1CAPSRBMixin = `
  font: 700 14px/24px Roboto, sans-serif;

  text-transform: uppercase;
`;

export const TextButton2CAPSRBMixin = `
  font: 700 12px/24px Roboto, sans-serif;

  text-transform: uppercase;
`;

export const TextMetric1ORMixin = `
  font: 400 32px/48px Oswald, sans-serif;
  text-transform: uppercase;
`;

export const TextMetric2OMMixin = `
  font: 500 24px/36px Oswald, sans-serif;
  text-transform: uppercase;
`;

export const TextMetric3OMMixin = `
  font: 500 20px/28px Oswald, sans-serif;
  text-transform: uppercase;
`;

export const TextMetric4RMMixin = `
  font: 500 14px/20px Roboto, sans-serif;
`;
